const updatesData = [
  {
    time: '2026-07-28',
    title: '黑料每日大赛七月总决赛投票通道开启',
    desc: '七月大赛进入最终投票阶段，12位热门选手争夺本月冠军，快来为你支持的选手投票。',
    tag: '大赛动态',
  },
  {
    time: '2026-07-27',
    title: '黑料平台移动端重大更新：新增离线缓存功能',
    desc: '手机客户端v3.8版本上线离线缓存功能，支持WiFi下自动预加载，无网络也能看黑料视频。',
    tag: '功能更新',
  },
  {
    time: '2026-07-26',
    title: '热门话题 #某艺人合约纠纷# 内容专区上线',
    desc: '针对近期持续发酵的艺人合约纠纷事件，平台推出专属内容聚合页，事件全程梳理一目了然。',
    tag: '内容更新',
  },
  {
    time: '2026-07-25',
    title: '黑料网服务器全面升级，观看体验再提升',
    desc: '完成服务器架构升级，视频加载速度提升50%，高峰期也能流畅观看，用户体验全面优化。',
    tag: '平台动态',
  },
  {
    time: '2026-07-24',
    title: '八月黑料每日大赛预告：全新赛制重磅来袭',
    desc: '八月大赛将采用全新1v1 PK淘汰赛制，参赛范围扩大至所有内容板块，更多精彩即将上线。',
    tag: '大赛预告',
  },
  {
    time: '2026-07-23',
    title: '黑料平台内容安全审核机制全面强化',
    desc: '引入AI+人工双重审核机制，确保平台内容真实可靠，为用户提供更安全的观看环境。',
    tag: '安全升级',
  },
  {
    time: '2026-07-22',
    title: '黑料在线视频播放器全新改版',
    desc: '新版播放器支持画质自适应、倍速播放、弹幕互动等功能，整体UI设计更加简洁美观。',
    tag: '功能更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新动态</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            黑料平台最新资讯与功能更新，随时了解平台动态
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/50 hidden sm:block"></div>

          <div className="space-y-6">
            {updatesData.map((item, idx) => (
              <div key={idx} className="flex gap-4 sm:gap-6">
                {/* Timeline dot & date */}
                <div className="hidden sm:flex flex-col items-center flex-shrink-0">
                  <div className={`w-[39px] h-[39px] rounded-full border-2 flex items-center justify-center bg-background-50 ${
                    idx === 0 ? 'border-primary-500' : 'border-background-300/50'
                  }`}>
                    <div className={`w-2.5 h-2.5 rounded-full ${
                      idx === 0 ? 'bg-primary-500' : 'bg-background-400'
                    }`}></div>
                  </div>
                </div>

                {/* Content card */}
                <div className={`flex-1 bg-background-100 border rounded-xl p-4 md:p-5 transition-all hover:border-primary-500/20 cursor-pointer ${
                  idx === 0 ? 'border-primary-500/30' : 'border-background-300/30'
                }`}>
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap ${
                      idx === 0 ? 'bg-primary-500/10 text-primary-400' : 'bg-background-200 text-foreground-500'
                    }`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}